import { Controller } from "@hotwired/stimulus"

// The shared "Im Katalog speichern" modal on the LV and billing document editors.
// Opened by a `catalog-save:open` event carrying the item ids to capture and a default
// name — dispatched by the bulk bars (live selection) and by catalog-save-trigger
// buttons (a single row, or the whole document with no ids at all). Listening on the
// document rather than exposing an action keeps the openers free to sit anywhere on the
// page, including inside the tree frame that gets replaced after every mutation.
// A successful save streams a fresh, closed modal in.
export default class extends Controller {
  static targets = ["form", "nameInput"]

  connect() {
    this.boundKeydown = this.onKeydown.bind(this)
    this.boundOpen = this.openFromEvent.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
    document.addEventListener("catalog-save:open", this.boundOpen)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown)
    document.removeEventListener("catalog-save:open", this.boundOpen)
  }

  openFromEvent(event) {
    const { ids = [], name = "" } = event.detail || {}
    this.setItemIds(ids)
    this.element.classList.remove("hidden")
    if (!this.hasNameInputTarget) return

    this.nameInputTarget.value = name
    this.nameInputTarget.focus()
  }

  // No ids at all is meaningful: the server then captures the document's whole tree.
  setItemIds(ids) {
    const form = this.hasFormTarget ? this.formTarget : this.element.querySelector("form")
    if (!form) return

    form.querySelectorAll("input[name='item_ids[]']").forEach((el) => el.remove())
    ids.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "item_ids[]"
      input.value = id
      form.appendChild(input)
    })
  }

  close() {
    this.element.classList.add("hidden")
  }

  onKeydown(event) {
    if (event.key === "Escape" && !this.element.classList.contains("hidden")) this.close()
  }
}
